import { render, staticRenderFns } from "./MediaFavoriteIcon.vue?vue&type=template&id=db9178f8&"
import script from "./MediaFavoriteIcon.vue?vue&type=script&lang=js&"
export * from "./MediaFavoriteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports